import { Component, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  ModalitaPagamento,
  PaymentMethodRequestType,
} from '../../../models/fisso';
import { AlgConsensoService } from '../../../services/alg-consenso.service';

@Component({
  selector: 'alg-payment-consents',
  templateUrl: './alg-payment-consents.component.html',
  styleUrls: ['./alg-payment-consents.component.scss'],
})
export class AlgPaymentConsentsComponent implements OnInit {
  public consentForm: FormGroup;
  isChecked = false;
  isDirty = false;
  fileUploaded = false;
  @Input() paymentMethodRequest: ModalitaPagamento;
  @Input() isThirdPartyRequest: boolean;

  PaymentMethodRequestType = PaymentMethodRequestType;

  constructor(private consensoService: AlgConsensoService) {}

  ngOnInit() {
    if (
      this.paymentMethodRequest.paymentMethod ==
      PaymentMethodRequestType.bollettino
    ) {
      this.consensoService.paymentConsentSubject$.next(true);
    } else if (!this.isThirdPartyRequest) {
      this.fileUploaded = true;
    } else if (this.paymentMethodRequest.paymentMethod == PaymentMethodRequestType.sepa && this.isThirdPartyRequest) {
      this.isChecked = true;
    }
  }

  onUploadDocumentCompleted(event: any) {
    this.fileUploaded = true;
    this.consensoService.paymentConsentSubject$.next(this.isChecked);
  }

  onCheckboxChange(event: any) {
    this.isChecked = event.target.checked; // Aggiorna lo stato locale
    this.consensoService.paymentConsentSubject$.next(this.isChecked && this.fileUploaded);
    this.isDirty = true;
  }

  getLabel() {
    switch (this.paymentMethodRequest.paymentMethod) {
      case PaymentMethodRequestType.libretto:
        return 'PAYMENT_CONSENTS_DESCRIPTION_LIBRETTO';
      case PaymentMethodRequestType.sepa:
        return 'PAYMENT_CONSENTS_DESCRIPTION_SEPA';

      default:
        return '';
    }
  }

  getDescription() {
    switch (this.paymentMethodRequest.paymentMethod) {
      case PaymentMethodRequestType.libretto:
        return 'PAYMENT_CONSENTS_ACCEPT_CHECKBOX';
      case PaymentMethodRequestType.sepa:
        return 'PAYMENT_CONSENTS_AUTORIZE_CHECKBOX';
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-payment-method/alg-payment-consents/alg-payment-consents.component.ts